import {loadStripe} from "@stripe/stripe-js";

const stripe = () => {
    const stripe_pk = window.location.hostname === "localhost" ?
        "pk_test_muXl1YzclFPw37isyR2haJN500eeoYtTWf" : "pk_live_n7eO3bYkVLdFNLayw0PZtDzE00aDdZgAQF";
    return loadStripe(stripe_pk);
};

export default stripe;
